import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Offcanvas from '../components/Offcanvas';
import SearchArea from '../components/SearchArea';
import BreadcrumbSection from '../components/BreadcrumbSection';
import TourPackageDetails from '../components/TourPackageDetails';
import { API_BASE_URL } from '../config/config.js';

function TourPackageDetailsPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
//   const category = queryParams.get('category');
  const value = queryParams.get('value'); // This is the slug
  const [tourData, setTourData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTourDetails = async () => {
      try {
        setLoading(true);
        const apiUrl = `${API_BASE_URL}/api/v1/tour-package/${value}`;
        console.log('Fetching from:', apiUrl);
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log('Response data:', data);

        // Pass the full data.data object without normalization
        setTourData(data.data);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTourDetails();
  }, [value]);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5 text-danger">Error: {error}</div>;

  return (
    <>
      <Offcanvas />
      <SearchArea />
      <Header />
      <BreadcrumbSection />
      {tourData && <TourPackageDetails tour={tourData} />}
      <Footer />
    </>
  );
}

export default TourPackageDetailsPage;